var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.displayStyle')
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.optionModel.displayStyle),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "displayStyle", $$v)
      },
      expression: "optionModel.displayStyle"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "inline"
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.inlineLayout')))]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "block"
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.blockLayout')))])], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-834ae27e","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/property-editor/displayStyle-editor.vue
// module id = null
// module chunks = 